import axios from 'axios';
import { API_URL } from './baseUrl';

export const getsealosdata = async (name, keshi, hospital,role) => {
    try {
        const response = await axios.get(`${API_URL}/referralpatient`, {
            params: {
                flag: 'getdata',
                name,
                keshi,
                hospital,role
            }
        });
        console.log('获取信息成功', response.data);

        return response.data; // 返回患者信息
    } catch (error) {
        console.error("获取信息失败:", error);
        throw error; // 抛出错误以便调用者处理
    }
};


export const getsealospatientdata = async (patientid) => {
    try {
        const response = await axios.get(`${API_URL}/referralpatient`, {
            params: {
                flag: 'getpatientdata',
                patientid
            }
        });
        console.log('获取信息成功', response.data);

        return response.data; // 返回患者信息
    } catch (error) {
        console.error("获取信息失败:", error);
        throw error; // 抛出错误以便调用者处理
    }
};


export const dealsealosdata = async (id, status, rejectReason) => {
    try {
        const response = await axios.post(`${API_URL}/referralpatient`, {
            postflag: 'edit',
            id,
            status,
            rejectReason
        });
        console.log('编辑信息成功', response.data);

        return response.data; // 返回患者信息
    } catch (error) {
        console.error("编辑信息失败:", error);
        throw error; // 抛出错误以便调用者处理
    }
};




export const jzzksealosdata = async (id, status, department, doctorName, originalDepartment, originalDoctor, oldstatus) => {
    try {
        const response = await axios.post(`${API_URL}/referralpatient`, {
            postflag: 'editzk',
            id,
            status, department, doctorName, originalDepartment, originalDoctor, oldstatus
        });
        console.log('转科成功', response.data);

        return response.data; // 返回患者信息
    } catch (error) {
        console.error("转科失败:", error);
        throw error; // 抛出错误以便调用者处理
    }
};



// // 编辑患者信息的请求函数
// export const editPatientInfo = async (id, data) => {
//     try {
//         const response = await axios.post(`${API_URL}/patient`, {
//             flag: 'edit',
//             id,
//             data

//         });
//         console.log('编辑患者信息成功', response.data);

//         return response.data; // 返回患者信息
//     } catch (error) {
//         console.error("编辑患者信息失败:", error);
//         throw error; // 抛出错误以便调用者处理
//     }
// };

// // 删除患者信息的请求函数
// export const deletePatientInfo = async (id) => {
//     try {
//         const response = await axios.post(`${API_URL}/patient`, {
//             flag: 'delete',
//             id
//         });
//         console.log('删除信息成功', response.data);

//         return response.data; // 返回患者信息
//     } catch (error) {
//         console.error("删除患者信息失败:", error);
//         throw error; // 抛出错误以便调用者处理
//     }
// };
